import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { KCloudIntegrationField } from "@/features/accounts/account-group/components/kcloud-integration-field";
import type { KCloudIntegrationInfo } from "@/features/accounts/account-group/hooks/use-kcloud-integration";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { DisconnectKCloudConfirmModal } from "@/features/accounts/account-group/components/disconnect-kcloud-confirm-modal";
import { SimpleForm } from "@/shared/components/text-box/simple-form";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";


interface Props {
  onTapCloseModal: () => void;
  onOpenConnectModal: (serviceType: "kaikei" | "shokokai") => void;
  serviceIntegrationInfo: KCloudIntegrationInfo | null;
  onDisconnect?: (serviceType: "kaikei" | "shokokai") => void;
}

export const KCloudIntegrationModal = ({ 
  onTapCloseModal, 
  onOpenConnectModal,
  serviceIntegrationInfo,
  onDisconnect
}: Props) => {

  // 会計事務所クラウド連携フラグ（serviceType: 1）
  const isKaikeiIntegrated = 
  serviceIntegrationInfo?.serviceType === 1 && 
  serviceIntegrationInfo?.uniClientCode !== 0;

// 商工会クラウド連携フラグ（serviceType: 2 かつ 顧問先情報が登録済み）
const isShokokaiIntegrated = 
  serviceIntegrationInfo?.serviceType === 2 && 
  serviceIntegrationInfo?.uniClientCode !== 0;

// const handleDisconnect = async () => {
//   if (onDisconnect && window.confirm("サービス連携を解除しますか？")) {
//     await onDisconnect();
//   }
// };
const {
  targetAccountGroup,
} = useAccountGroupsContext();

const { openMyDataModal, setOpenMyDataModal } = useModalContext();

const onTapDisconnect = () => {
  setOpenMyDataModal("DisconnectConfirmModal");
}

const handleExecDisconnect = async () => {
  setOpenMyDataModal(undefined); // モーダルを閉じる
  if (onDisconnect) {
    const serviceType = serviceIntegrationInfo?.serviceType === 2 ? "shokokai" : "kaikei";
    await onDisconnect(serviceType);
  }
};

  return (
    <>
      {openMyDataModal === "ServiceIntegration" && (
        <BasePageModal
          title="サービス連携"
          className="md-user-joint"
          handleClose={() => {
            onTapCloseModal();
          }}
        >
          <h2>明細データが共有できます</h2>
          <div className="group-name md-bank-style">
            <div className="label">グループ名</div>
            <div className="value">{targetAccountGroup.accountGroupsName}</div>
          </div>
            <>
              {/* 会計事務所クラウド */}
              <KCloudIntegrationField
                checkboxId="checkJoint01"
                serviceName="会計事務所クラウド"
                isIntegrated={isKaikeiIntegrated}
                isOtherServiceIntegrated={isShokokaiIntegrated}
                serviceIntegrationInfo={isKaikeiIntegrated ? serviceIntegrationInfo : null}
                onConnect={() => onOpenConnectModal("kaikei")}
                onDisconnect={onTapDisconnect}
              />

              {/* 商工会クラウド */}
              <KCloudIntegrationField
                checkboxId="checkJoint02"
                serviceName="商工会クラウド"
                isIntegrated={isShokokaiIntegrated}
                isOtherServiceIntegrated={isKaikeiIntegrated}
                serviceIntegrationInfo={isShokokaiIntegrated ? serviceIntegrationInfo : null}
                onConnect={() => onOpenConnectModal("shokokai")}
                onDisconnect={onTapDisconnect}
              />
            </>
        </BasePageModal>
      )}

      {openMyDataModal === "DisconnectConfirmModal" && (
        <DisconnectKCloudConfirmModal
          title="確認"
          message="サービス連携を解除しますか？"
          onTapOk={handleExecDisconnect}
          onTapCancel={() => setOpenMyDataModal(undefined)}
        />
      )}
    </>
  );
};